import React, { useEffect, useState } from 'react';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./wysiwyg.scss";

import 'katex/dist/katex.min.css';
import katex from 'katex';
window.katex = katex; // Make KaTeX globally available for Quill

export default function Wysiwyg2(props) {

   // Keep an internal controlled value so we can:
   // - initialize from props.content
   // - optionally update parent on each change (updateOnChange)
   // - still support the older "update on blur" behavior by default
   const [editorValue, setEditorValue] = useState(props.content ?? '');

   // If parent changes the content (e.g., restoring draft, switching item), sync it.
   useEffect(() => {
      const next = props.content ?? '';
      // Avoid unnecessary sets to reduce cursor jumps
      if (next !== editorValue) setEditorValue(next);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.content]);

   const Quill = ReactQuill.Quill;

   // Register the formula module
   const Formula = Quill.import('modules/formula');
   Quill.register(Formula, true);

   var Font = Quill.import("formats/font");
   Font.whitelist = ["Inter", "Italianno", "Monoton", "Pacifico", "Righteous", "Roboto", "Sevillana"];
   Quill.register(Font, true);

   var Size = Quill.import('attributors/style/size');
   Size.whitelist = ['14px', '16px', '20px', '24px', '32px', '42px', '54px', '68px', '84px', '98px'];
   Quill.register(Size, true);

   var modules = {
      formula: true,
      toolbar: [
         // { header: "1" },
         // { header: "2" },
         // // { size: ['small', false, 'large', 'huge'] },
         // { 'font': Font.whitelist },
         // { 'size': Size.whitelist },
         // "bold", "italic", "underline", "strike", "blockquote",
         // { color: [] }, { background: [] },
         // { align: [] },
         // { list: "ordered" },
         // { list: "bullet" },
         // { indent: "-1" },
         // { indent: "+1" },
         // 'link'

         [{ header: "1" }, { header: "2" }],
         // [{ size: ['small', false, 'large', 'huge'] }],
         [{ 'font': Font.whitelist }],
         [{ 'size': Size.whitelist }],
         ["bold", "italic", "underline", "strike", "blockquote"],
         [{ color: [] }, { background: [] }],
         [
            { align: [] },
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
         ],
         ['link', 'formula'],
         // ['formula',],
         // ['clean']
      ],
      clipboard: {
         // toggle to add extra line breaks when pasting HTML:
         matchVisual: false,
      }
   };

   var noToolbar = {
      toolbar: false,
      clipboard: {
         // toggle to add extra line breaks when pasting HTML:
         matchVisual: false,
      }
   }

   var formats = [
      "header",
      "size",
      "font",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "background",
      //  "code",
      "align",
      "list",
      "bullet",
      "indent",
      "link",
      "formula",
      "script",
      "color",
      "clean"
   ];

   const handleUpdateContent = () => {
      // Default behavior: push changes only on blur
      if (!props.updateOnChange) {
         props.changeContentCallback(editorValue);
      }
   }

   const handleChangeContent = (value) => {
      setEditorValue(value);

      // Optional behavior: push changes immediately (useful for draft persistence)
      if (props.updateOnChange) {
         props.changeContentCallback(value);
      }
   }
   return (
      <div style={{ height: props.height, background: "white", borderRadius: "7px", border: "1px solid #ccc" }} onBlur={handleUpdateContent}>
         <ReactQuill
            id={'brainee' + props.id}
            key={'brainee' + props.id}
            style={{
               width: "100%",
               //   backgroundSize: "auto 100%",
               //   backgroundRepeat: "no-repeat",
               maxHeight: props.disabled ? props.height - 10 : props.contentHeight,
               height: props.disabled ? props.height - 10 : props.contentHeight,
               // overflow: "auto",
               backgroundColor: "white",
               borderRadius: "7px",
            }}
            theme='snow'
            value={editorValue}
            onChange={handleChangeContent}
            // onBlur={(range, source, quill) => {
            //    handleChangeContent(quill.getHTML());
            //   }}
            modules={props.disabled ? noToolbar : modules}
            formats={formats}
            readOnly={props.disabled}
         />
      </div>
   );
}